import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Select from 'react-select';
import Constants from '../../config/constants';
import Layout from '../../components/layout/Layout';
import Thumbnail from '../../components/thumbnail/Thumbnail';
import DataTable from '../../components/datatable/DataTable';
import Alert from '../../modal/alert/Alert';
import VRFOutdoorCreateModal from '../../modal/vrf/VRFOutdoorCreateModal';
import VRFOutdoorEditModal from '../../modal/vrf/VRFOutdoorEditModal';
import VRFOutdoorDuplicateModal from '../../modal/duplicate/VRFOutdoorDuplicateModal';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import {
  defaultRejectHandler,
  getErrorValue,
  withDefaultSort,
} from '../../utils/utility';
import {
  listVRFOutdoor,
  deleteVRFOutdoor,
  clearErrorVRFOutdoor,
} from '../../redux/vrf/vrf_outdoor_actions';

export class VRFOutdoorPage extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    this.columns = [
      {
        Header: '',
        accessor: 'thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      { Header: () => <b>{t('name')}</b>, accessor: 'name', ...textColumn },
      {
        Header: () => <b>{t('category')}</b>,
        accessor: 'is_public',
        Cell: row =>
          row.value ? (
            <span>
              <i className="fas fa-users" /> {t('public')}
            </span>
          ) : (
            <span>
              <i className="fas fa-user" /> {t('private')}
            </span>
          ),
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('brand')}</b>,
        accessor: 'brand_name',
        ...textColumn,
        width: 90,
      },
      {
        Header: () => <b>{t('cooling capacity')}</b>,
        accessor: 'cooling_capacity',
        ...coeColumn,
        width: 110,
      },
      {
        Header: () => <b>{t('unit')}</b>,
        accessor: 'unit',
        ...textColumn,
        width: 80,
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'power',
        ...coeColumn,
        width: 100,
      },
      {
        Header: () => <b>{t('fan power (kW)')}</b>,
        accessor: 'fan_power',
        ...coeColumn,
        width: 110,
      },
      {
        Header: () => <b>{t('SEER')}</b>,
        accessor: 'seer',
        ...coeColumn,
        width: 80,
      },
      {
        Header: () => <b>COP</b>,
        accessor: 'cop',
        Cell: row => (row.value == null ? '-' : row.value),
        ...coeColumn,
        width: 80,
      },
      {
        Header: () => (
          <b>
            {t('cfp')}
            <br />({t('kgCO2eq per unit')})
          </b>
        ),
        accessor: 'cfp_value',
        Cell: row => `${Number(row.value || 0)} ${row.original.cfp_unit || ''}`,
      },
    ];

    this.state = {
      selectedItem: null,
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowDuplicateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.isCreating &&
      nextProps.isCreating !== this.props.isCreating &&
      !nextProps.errorMessage
    ) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }
    if (
      this.props.isEditing &&
      nextProps.isEditing !== this.props.isEditing &&
      !nextProps.errorMessage
    ) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }
    if (
      this.props.isDeleting &&
      nextProps.isDeleting !== this.props.isDeleting &&
      !nextProps.errorMessage
    ) {
      this.setState({ isShowDeleteModal: false });
    }
    if (
      this.props.isDuplicating &&
      nextProps.isDuplicating !== this.props.isDuplicating &&
      !nextProps.errorMessage
    ) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  renderActionMenu() {
    return [
      <li>
        <a
          href="#"
          id="vrf-outdoor-create"
          onClick={() =>
            this.setState({ isShowCreateModal: true, isCreated: false })
          }
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">
            {this.props.t('create vrf outdoor')}
          </span>
        </a>
      </li>,
    ];
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    this.props.list(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      { all: null, public: true, private: false }[category.value],
    );
    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }
  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }
  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }
  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      categoryOption,
      selectedItem: item,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filtered,
      filteredCount,
      isLoading,
      isDeleting,
      isDuplicating,
      t,
      errorMessage,
    } = this.props;

    const breadcrumbItems = [
      { name: t('air conditioning system'), path: '/ac' },
      { name: t('vrf outdoor'), path: '/ac/vrf_outdoor' },
    ];

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
      >
        <VRFOutdoorCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
        />
        <VRFOutdoorEditModal
          outdoor={item}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
        />
        <VRFOutdoorDuplicateModal
          item={item}
          show={isShowDuplicateModal}
          title={t('copy vrf outdoor')}
          label={t('new vrf outdoor')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete vrf outdoor')}
          body={`${t('do you want to delete')} ${item ? item.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.remove(item)}
        />
        <h1>{t('vrf outdoor')}</h1>
        <div style={{ backgroundColor: 'white' }}>
          <div
            className="filter-box"
            style={{ display: 'flex', padding: 20, marginBottom: 20 }}
          >
            <input
              id="vrf-outdoor-search-name"
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event =>
                this.updateSortFilter(event.target.value, null, categoryOption)
              }
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <DataTable
            columns={this.columns}
            data={this.props.list_data}
            onActionEdit={i =>
              this.setState({
                isShowEditModal: true,
                selectedItem: i.original,
                isEdited: false,
              })
            }
            onActionDuplicate={i =>
              this.setState({
                isShowDuplicateModal: true,
                selectedItem: i.original,
                isDuplicated: false,
              })
            }
            onActionDelete={i =>
              this.setState({
                isShowDeleteModal: true,
                selectedItem: i.original,
              })
            }
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state =>
              this.updateSortFilter(filtered, state, categoryOption)
            }
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  list_data: state.vrfOutdoor.orderedIds.map(
    id => state.vrfOutdoor.objects[id],
  ),
  filteredCount: state.vrfOutdoor.filteredCount,
  isLoading: state.vrfOutdoor.isLoading,
  isCreating: state.vrfOutdoor.isCreating,
  isEditing: state.vrfOutdoor.isEditing,
  isDeleting: state.vrfOutdoor.isDeleting,
  isDuplicating: state.vrfOutdoor.isDuplicating,
  errorMessage: state.vrfOutdoor.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  list: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listVRFOutdoor(pageSize, page, sorted, filtered, isPublic)),
    ),
  remove: item => defaultRejectHandler(dispatch(deleteVRFOutdoor(item.id))),
  clearError: () => dispatch(clearErrorVRFOutdoor()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(VRFOutdoorPage),
);



// WEBPACK FOOTER //
// ./src/pages/vrf/VRFOutdoorPage.js